import type { Lang } from '@/i18n/locale';
import type { FitnessExerciseProgressCopy } from '@/i18n/fitnessExperienceTypes';
import { requireFitnessExperienceCopy } from '@/i18n/translations';
export type { FitnessExerciseProgressCopy } from '@/i18n/fitnessExperienceTypes';

/** Synchronous after the shared locale boot/readiness boundary. */
export const fitnessExerciseProgressCopy = (lang: Lang): FitnessExerciseProgressCopy => requireFitnessExperienceCopy(lang, 'progress');
